{
  "app": {
    "name": "Shop admin",
    "loading": "Loading…",
    "language": "Language",
    "skip_to_content": "Skip to the main content"
  },
  "auth": {
    "sign_in_title": "Sign in",
    "sign_in_intro": "Staff account for the shop back office.",
    "email": "Email",
    "password": "Password",
    "sign_in": "Sign in",
    "sign_out": "Sign out",
    "signing_in": "Signing in…",
    "not_available": "Sign-in is not connected yet. Staff accounts arrive with the identity service.",
    "invalid": "Email or password is incorrect.",
    "dev_bypass_hint": "Development mode: any email and password will sign you in.",
    "forbidden_title": "You do not have access to this page",
    "forbidden_body": "Ask the shop owner to give your account the right permission."
  },
  "home": {
    "title": "What do you want to do today?",
    "add_card": "Add a card",
    "add_card_hint": "Register a new card for sale in about 2 minutes",
    "view_orders": "View orders",
    "view_orders_hint": "Web and in-store orders in one place",
    "ship": "Ship orders",
    "ship_hint": "Pack, add tracking, notify the customer",
    "open_pos": "Open the register",
    "open_pos_hint": "Start a shift on the in-store POS",
    "todo_empty": "Nothing to do right now.",
    "edit_banner": "Change the homepage banner",
    "edit_banner_hint": "Opens the website editor on the big picture at the top of the homepage"
  },
  "nav": {
    "home": "Home",
    "orders": "Orders",
    "products": "Products",
    "inventory": "Stock",
    "menu": "Menu",
    "online_store": "Website design",
    "content": "Website content",
    "more": "Menu",
    "main": "Main menu",
    "quick": "Quick menu",
    "section": "On this menu",
    "close_menu": "Close the menu",
    "coming_soon": "Coming soon",
    "external": "(opens the register app)",
    "groups": {
      "home": "Home",
      "orders": "Orders",
      "products": "Products",
      "inventory": "Stock",
      "customers": "Customers",
      "consignment": "Consignment",
      "pos": "Register (POS)",
      "discounts": "Discount codes",
      "content": "Website content",
      "online_store": "Online shop",
      "settings": "Settings"
    },
    "items": {
      "home": "Home",
      "orders_all": "All orders",
      "orders_bank_transfers": "Bank transfers to check",
      "orders_drafts": "Draft orders",
      "orders_pickups": "Store pickups",
      "orders_returns": "Returns and refunds",
      "orders_export_evidence": "Export proof (輸出免税)",
      "orders_documents": "Find documents (電帳法)",
      "products_all": "Products",
      "products_catalog": "Card catalog",
      "products_collections": "Collections",
      "products_categories": "Categories",
      "products_brands": "Brands",
      "products_attributes": "Extra product details",
      "products_import_export": "Import / export",
      "inventory_stock": "Stock levels",
      "inventory_movements": "Stock history",
      "inventory_receipts": "Receive stock",
      "inventory_transfers": "Transfers",
      "inventory_counts": "Stock counts",
      "inventory_holds": "Reserved cards",
      "inventory_conflicts": "Sold twice — decide",
      "inventory_live_shows": "Live shows",
      "inventory_locations": "Shops and warehouses",
      "customers_all": "Customers",
      "customers_groups": "Groups and tags",
      "customers_store_credit": "Store credit",
      "consignment_consignors": "Consignors",
      "consignment_items": "Consigned cards",
      "consignment_settlements": "Sales to settle",
      "consignment_payouts": "Payments to consignors",
      "consignment_requests": "Consignment requests",
      "consignment_kobutsu": "古物台帳 (second-hand register)",
      "pos_open": "Open the register",
      "pos_registers": "Registers",
      "pos_shifts": "Shifts and Z-reports",
      "pos_buylist": "Buy-ins (買取)",
      "pos_cash": "Cash in / out",
      "discounts": "Discount codes",
      "content_pages": "Pages",
      "content_policies": "Shop rules and policies",
      "content_menus": "Menus",
      "content_media": "Pictures and files",
      "content_announcements": "Announcements",
      "content_redirects": "Old web addresses",
      "content_translations": "Translations",
      "content_website_texts": "Website texts",
      "online_store_themes": "Website design",
      "online_store_markets": "Countries and currencies",
      "online_store_languages": "Website languages",
      "online_store_seo": "Search engines (SEO)",
      "online_store_domains": "Web address (domain)",
      "settings_store": "Shop details",
      "settings_tax": "Tax (消費税)",
      "settings_shipping": "Shipping",
      "settings_payments": "Payments",
      "settings_checkout": "Checkout",
      "settings_notifications": "Notifications",
      "settings_inventory": "Stock rules",
      "settings_pos": "Register rules",
      "settings_staff": "Staff",
      "settings_roles": "Roles and what they may do",
      "settings_api_keys": "Connections for other apps",
      "settings_audit": "Change history",
      "settings_jobs": "Background tasks and backups",
      "settings_features": "Features for later",
      "settings_website_refresh": "Website refresh",
      "settings_channels": "Marketplaces (eBay, Whatnot…)",
      "settings_analytics": "Reports and analytics",
      "help": "Help",
      "profile": "My account",
      "inbox": "To-do and alerts"
    },
    "badge_conflicts_one": "{{count}} problem to check",
    "badge_conflicts_other": "{{count}} problems to check",
    "badge_requests_one": "{{count}} new consignment request",
    "badge_requests_other": "{{count}} new consignment requests"
  },
  "header": {
    "search": "Search",
    "search_hint": "Search anything (⌘K)",
    "inbox": "To-do and alerts",
    "inbox_count": "To-do and alerts: {{count}} open",
    "inbox_critical": "{{count}} urgent",
    "user_menu": "My account menu",
    "profile": "My account",
    "help": "Help",
    "open_menu": "Open the full menu",
    "inbox_new_title": "New to-do"
  },
  "page": {
    "help": "Help for this page",
    "back": "Back"
  },
  "states": {
    "loading": "Loading…",
    "error_title": "This could not be loaded",
    "error_body": "Check the connection and try again.",
    "retry": "Try again",
    "empty_title": "Nothing here yet",
    "building_title": "This screen is on its way",
    "building_body": "{{title}} arrives in a coming update. Everything else keeps working.",
    "building_action": "Back to home",
    "coming_soon_title": "Coming in a later phase",
    "coming_soon_body": "{{title}} is switched off for now. The owner will turn it on when the shop is ready."
  },
  "errors": {
    "not_found_title": "Page not found",
    "not_found_body": "This page does not exist yet or has moved.",
    "back_home": "Back to home",
    "boundary_title": "Something went wrong on this page",
    "boundary_body": "Your other screens are fine. Try again, or go back to home.",
    "try_again": "Try again",
    "reference": "Reference code: {{id}}",
    "copy_reference": "Copy reference code",
    "copied": "Copied",
    "problem_how_to_fix": "Problem — tap to see how to fix it",
    "how_to_fix": "What to do next"
  },
  "money": {
    "tax_included": "tax incl.",
    "tax_excluded": "excl. tax {{amount}}"
  },
  "date": {
    "jst": "JST"
  },
  "rank": {
    "A": "Like new (美品)",
    "B": "Light wear (軽い傷)",
    "C": "Visible wear (傷あり)",
    "D": "Damaged (ダメージ)",
    "damaged": "Damaged",
    "scale": "A 美品 · B 軽い傷 · C 傷あり · D ダメージ",
    "badge_label": "Rank {{rank}} — {{label}}",
    "select_label": "Card condition (rank)",
    "select_hint": "Pick the letter that matches the card. Customers always see it.",
    "damaged_label": "Really damaged (creases, tears, water marks)",
    "ebay_preview": "On eBay this will show as: {{condition}}",
    "ebay_note": "Only used when cards are listed on eBay in the future.",
    "ebay": {
      "A": "Near Mint or Better",
      "B": "Lightly Played",
      "C": "Moderately Played",
      "D": "Heavily Played",
      "D_damaged": "Damaged"
    }
  },
  "status": {
    "active": "On sale",
    "draft": "Draft",
    "problem": "Problem",
    "pending": "Waiting",
    "archived": "Archived",
    "info": "Info"
  },
  "toast": {
    "region": "Messages",
    "undo": "Undo",
    "undo_seconds": "Undo ({{seconds}} s)",
    "undone": "Undone",
    "undo_failed": "Could not undo",
    "dismiss": "Close message",
    "more": "{{count}} more messages"
  },
  "confirm": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "what_happens": "What will happen",
    "reason_label": "Reason (saved in the history)",
    "reason_placeholder": "e.g. damaged in the shop, counted again",
    "reason_required": "Write a short reason"
  },
  "offline": {
    "banner": "No internet — what you type is kept and saved when you are back online.",
    "back_online": "Back online"
  },
  "forms": {
    "required": "Required",
    "optional": "Optional",
    "saving": "Saving…",
    "save": "Save",
    "draft_saved_at": "Draft saved {{time}}",
    "restore_title": "Restore your draft?",
    "restore_body": "You started this form on {{time}} and did not save it.",
    "restore": "Restore draft",
    "discard": "Start over",
    "leave_title": "Leave without saving?",
    "leave_body": "What you typed on this page is not saved yet. A draft is kept on this device.",
    "leave": "Leave the page",
    "stay": "Stay here",
    "conflict_title": "Someone changed this before you",
    "conflict_body": "{{name}} saved a newer version. Load the latest to see the change, or keep yours and save over it.",
    "conflict_someone": "Another staff member",
    "load_latest": "Load latest",
    "overwrite": "Keep mine and save",
    "fix_errors": "Please fix {{count}} item(s) marked in red.",
    "help": "What is this?",
    "help_more": "Read more",
    "select_placeholder": "Choose…",
    "select_search": "Type to search",
    "select_empty": "Nothing matches",
    "on": "On",
    "off": "Off",
    "yen_hint": "Whole yen, tax included",
    "date_hint": "Japan time (JST)"
  },
  "table": {
    "rows_per_page": "Rows per page",
    "next": "Next",
    "previous": "Previous",
    "page_rows": "{{count, number}} shown",
    "total": "{{count, number}} in total",
    "filters": "Filters",
    "open_filters": "Filters ({{count}})",
    "clear_filters": "Clear all",
    "remove_filter": "Remove filter {{name}}",
    "apply": "Show results",
    "any": "Any",
    "yes": "Yes",
    "no": "No",
    "search": "Search",
    "from": "From",
    "to": "To",
    "today": "Today",
    "last_7_days": "Last 7 days",
    "this_month": "This month",
    "saved_views": "Saved views",
    "all_rows": "All",
    "save_view": "Save this view",
    "view_name": "Name of the view",
    "rename_view": "Rename",
    "delete_view": "Delete",
    "delete_view_title": "Delete the view \"{{name}}\"?",
    "delete_view_body": "Only the saved filters are removed — no data is deleted.",
    "pin_view": "Pin to the top",
    "unpin_view": "Unpin",
    "view_saved": "View \"{{name}}\" saved",
    "view_deleted": "View deleted",
    "columns": "Columns",
    "show_column": "Show {{name}}",
    "move_up": "Move {{name}} up",
    "move_down": "Move {{name}} down",
    "pin_left": "Keep {{name}} on the left",
    "density": "Row height",
    "density_comfortable": "Roomy",
    "density_compact": "Compact",
    "export_csv": "Download CSV",
    "exporting": "Preparing the file…",
    "exported": "CSV downloaded",
    "selected_count": "{{count, number}} selected",
    "clear_selection": "Clear selection",
    "select_all": "Select all on this page",
    "select_row": "Select row",
    "sort_by": "Sort by {{name}}",
    "loading": "Loading rows…",
    "empty": "No rows match. Try other filters.",
    "error": "The list could not be loaded.",
    "actions": "Actions",
    "yen_column": "{{name}} (¥)",
    "load_more": "Show more"
  },
  "roles": {
    "owner": "Owner",
    "manager": "Manager",
    "staff": "Shop staff",
    "cashier": "Cashier",
    "content_editor": "Website editor",
    "consignment_manager": "Consignment manager"
  },
  "permissions": {
    "needs_owner": "Only the owner can do this",
    "needs_manager": "Needs a manager — ask a manager or the owner",
    "needs_other": "Your account cannot do this — ask the owner for access"
  },
  "flags": {
    "when": "Can be switched on later, when the owner decides",
    "page_intro": "This part is switched off for now. Everything else in the admin works as usual.",
    "payments_stripe": {
      "title": "Card payments online (Stripe)",
      "body": "Customers pay by card, Apple Pay or Google Pay on the website."
    },
    "payments_stripe_connect": {
      "title": "Pay consignors through Stripe",
      "body": "Consignor money goes straight to their bank account through Stripe."
    },
    "channels_ebay": {
      "title": "Sell on eBay",
      "body": "Cards go to eBay by themselves; a card sold anywhere is taken down everywhere."
    },
    "channels_whatnot": {
      "title": "Sell in Whatnot live shows",
      "body": "Show cards in live auctions; sold cards come back as orders."
    },
    "channels_mercari": {
      "title": "Sell on Mercari Shops",
      "body": "Offer cards on Mercari Shops from the same stock."
    },
    "channels_tiktok_shop": {
      "title": "Sell on TikTok Shop",
      "body": "Offer cards on TikTok Shop from the same stock."
    },
    "tax_nta_api": {
      "title": "Send tax-free records to the tax office automatically",
      "body": "Tax-free sale records go to the National Tax Agency without uploading a file."
    },
    "shipping_shipandco": {
      "title": "Shipping labels from Ship&co",
      "body": "Print carrier labels and tracking numbers in one step."
    },
    "shipping_zonos": {
      "title": "Import duties paid at checkout (Zonos)",
      "body": "Overseas customers pay the import duties when they order."
    }
  },
  "order_status": {
    "pending_payment": "Waiting for payment",
    "paid": "Paid",
    "partially_paid": "Partly paid",
    "partially_refunded": "Partly refunded",
    "refunded": "Refunded",
    "cancelled": "Cancelled"
  },
  "fulfillment_status": {
    "unfulfilled": "Not prepared yet",
    "preparing": "Preparing",
    "ready": "Packed, ready to ship",
    "shipped": "Shipped",
    "in_transit": "On the way",
    "delivered": "Delivered",
    "partial": "Partly shipped",
    "pickup_ready": "Ready for pickup",
    "picked_up": "Picked up",
    "return_requested": "Return requested",
    "return_received": "Return received"
  },
  "sortable": {
    "drag": "Drag {{name}}",
    "up": "Move {{name}} up",
    "down": "Move {{name}} down",
    "moved": "{{name}} is now number {{to}} of {{count}}"
  },
  "dialog": {
    "close": "Close",
    "cancel": "Cancel"
  },
  "copy": {
    "copy": "Copy",
    "copied": "Copied",
    "failed": "Select and copy by hand"
  },
  "live": {
    "menu": "Live updates",
    "menu_hint": "This screen updates by itself when something changes.",
    "toasts": "Show a message when something new happens",
    "sound": "Play a quiet sound with it",
    "new_order": "A new order just arrived",
    "transfer_notice": "A customer says they have paid by bank transfer",
    "payment_received": "Money received for an order",
    "pos_sale": "A sale was made at the counter",
    "oversell": "The same card was sold twice. Please check it now.",
    "consignment_request": "New request to leave cards for sale",
    "see": "See it on the list",
    "new_row": "New",
    "conflict": "Someone else changed this while you were editing.",
    "conflict_by": "{{name}} changed this while you were editing.",
    "reload": "Load latest"
  },
  "shop_switches": {
    "licence_missing": "Buying cards (買取) and taking cards on consignment are closed: the shop's 古物商許可 number is not saved yet.",
    "licence_fix": "Add it in Shop details",
    "web_orders_paused": "The website is not taking orders right now (paused). The shop counter works as usual.",
    "web_orders_open": "Open checkout settings"
  }
}
